<template>
  <div>
    <!-- 搜索框 -->
    <a-card title="日志采集">
      <v-gobackbutton slot="extra" type="primary" >返回</v-gobackbutton>
      <a-form layout="inline" @submit="handleSubmit" :form="form">
          <a-form-item label="版本">
            <a-radio-group v-model="searchP.version">
                <a-radio value="V3.0">
                3.0
                </a-radio>
                <a-radio value="V5.0">
                5.0
                </a-radio>
            </a-radio-group>
          </a-form-item>

          <a-form-item label="商户号">
                <ShopAutoComplete ref="shopcodeAs" @onShopCodeChange = "handleSearchShopcodeChange"></ShopAutoComplete>
          </a-form-item>


          <a-form-item label="设备号">
              <a-input  v-model="searchP.deviceno"  placeholder="请输入设备号" ></a-input>
          </a-form-item>

           <a-form-item>
                <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
          </a-form-item>

          <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                </a-button>
          </a-form-item>

      </a-form>
    </a-card>

    <!-- 系统列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="id" >
        <!-- <span slot="devicetype" slot-scope="text">{{flagname[text]}}</span> -->

      <template slot="isonline" slot-scope="text">
        <div >
          <span v-if="text=='1'" style="color:green">
            在线
          </span>
           <span v-else-if="text=='0'" style="color:red">
             离线   
          </span>
        </div>
      </template>
      <template slot="operation" slot-scope="text, record">
        <div >
         <span>
           <a-button type="link" @click="handle_auth_push(record)">采集</a-button>
          </span>
        </div>
      </template>

    </a-table>

   <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
     
  </div>
</template>
<script>
import { mapState } from "vuex";
import ShopAutoComplete from '@/components/ShopAutoComplete';
const data = [];

const flagname = {
    '1':'收银机',
    '2':'广告机 ',
    '3':'自助收银机 ',
};

let pagination={
    total:0,
    pageSize:0,
    current:1,
}
const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: "设备号",
        dataIndex: "deviceno",
        width:100
    },
    {
        title: "在线状态",
        dataIndex: "isonline",
        width:100,
        scopedSlots: { customRender: 'isonline' },
    },
    {
        title: "设备类型",
        dataIndex: "devicetype",
        width:150,
        // scopedSlots: { customRender: 'devicetype' },
    },
    {
        title: "创建时间",
        dataIndex: "createtime",
        width:150
    },
    {
        title: "更新时间",
        dataIndex: "updatetime",
        width:150
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            pagination,
            tLoading:true,
            flagname,
            currentItemList:'',
            datasource:{
                isShow:false,
                authedStr:''
            },
        };
    },
    methods: {
        handleSearchShopcodeChange(value){
            this.searchP.shopcodekey = value;
        },

        handlePageChange(c_p){
            this.getdeviceList(c_p)
        },
        getdeviceList(cpage){
            let c_params = {
                ...this.searchP
            }
            c_params.page =cpage ? cpage : 1;
            c_params.pageSize = this.pagination.pageSize;
            c_params.urlparams = false;
            this.tLoading = true;
            this.$store.dispatch({
                type: this.searchP.version == 'V3.0' ? "devicelog/getDevicenumListv3" : "devicelog/getDevicenumList",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                if(result){
                    this.data = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.current = parseInt(result.page);
                }
            })
        },
        handle_auth_push(ritem){
            let c_params = {
                deviceno:  ritem.deviceno,
                opversion: this.searchP.version
            }
            this.tLoading = true;
            this.$store.dispatch({
                type: this.searchP.version == 'V3.0' ? "devicelog/pushCommandv3" : "devicelog/pushCommand",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
            })
        },

        handleSearchReset(){
            this.$store.dispatch({
                type: "devicelog/getEmptySearch",
                showMsg: true
            })
            this.$refs.shopcodeAs.setInputVal(this.searchP.shopcodekey);
        },


        handleSubmit(e){
            e.preventDefault();
            if(this.searchP.version == 'V3.0'){
                columns[2] = {
                    title: "在线状态",
                    dataIndex: "isonline",
                    width:100,
                    scopedSlots: { customRender: 'isonline' }
                }
            }else{
                columns[2] = {
                    title: "在线状态",
                    dataIndex: "redisisonline",
                    width:100,
                    scopedSlots: { customRender: 'isonline' }
                }
            }
            this.getdeviceList()
        },

    },
    computed:{
        ...mapState('devicelog', {
            searchP: state => state.searchP,
        })
    },
    components:{
        ShopAutoComplete,
    },
    mounted(){
        this.$refs.shopcodeAs.setInputVal(this.searchP.shopcodekey);
        this.getdeviceList();
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
